<section *ngIf="!hideFilterAndSearchBar" class="search-sort-container">
    <div class="d-flex flex-wrap justify-content-lg-start justify-content-start align-items-end">
        <ca-search-input
            *ngIf="isSearchInputShown"
            class="search-field margin-to-fit-button"
            [searchTerm]="searchAndSortOptions.searchQuery"
            (onSearchTermChange)="onSearchTermChange($event)"
            [isSearchLoading]="isSearchLoading"
        ></ca-search-input>
        <ng-select
            tabindex="0"
            *ngIf="sortOptions"
            class="sort-field margin-to-fit-button"
            [items]="sortOptions"
            [(ngModel)]="sortByField"
            placeholder="{{ 'GENERAL.SORT_BY' | translate }}"
            [searchable]="false"
            [clearable]="false"
            (change)="onSortOptionsChange($event)"
            data-uit="sort-by-select"
        >
            <!-- Template for options in dropdown -->
            <ng-template ng-option-tmp let-item="item">
                <span>{{ item.label.replace(' asc', '  &uarr;').replace(' desc', '  &darr;') }}</span>
            </ng-template>
            <!-- Template for selected option -->
            <ng-template ng-label-tmp let-item="item">
                <span>{{ item.label.replace(' asc', '  &uarr;').replace(' desc', '  &darr;') }}</span>
            </ng-template>
        </ng-select>
        <ng-select
            tabindex="0"
            *ngIf="machineLearningWorkflowTypeOptions.length > 0"
            class="sort-field workflow-type-option margin-to-fit-button"
            [items]="machineLearningWorkflowTypeOptions"
            [(ngModel)]="selectedMachineLearningWorkflowTypeOptions"
            [multiple]="true"
            placeholder="{{ 'GENERAL.FILTERS.BY_MLWORKFLOWTYPE' | translate }}"
            [searchable]="false"
            [clearable]="true"
            (change)="onMachineLearningWorkflowTypeOptionsChange($event)"
            data-uit="mlWorkflowType-select"
        >
        </ng-select>
        <ng-select
            tabindex="0"
            *ngIf="userTypeOptions.length > 0"
            class="sort-field user-type-option margin-to-fit-button"
            [items]="userTypeOptions"
            [(ngModel)]="selectedUserTypeOptions"
            [multiple]="true"
            placeholder="{{ 'GENERAL.FILTERS.BY_USERTYPE' | translate }}"
            [searchable]="false"
            [clearable]="true"
            (change)="onUserTypeOptionsChange($event)"
            data-uit="userType-select"
        >
        </ng-select>
        <ng-select
            tabindex="0"
            *ngIf="stateOptions.length > 0"
            class="sort-field margin-to-fit-button"
            [items]="stateOptions"
            [(ngModel)]="selectedStateOption"
            [multiple]="false"
            placeholder="{{ 'GENERAL.FILTERS.BY_STATE' | translate }}"
            [searchable]="false"
            [clearable]="true"
            (change)="onStateOptionsChange($event)"
            data-uit="state-select"
        >
        </ng-select>
        <ng-select
            tabindex="0"
            *ngIf="showCategoryButton"
            class="sort-field margin-to-fit-button"
            [items]="categoryOptions"
            [(ngModel)]="selectedCategoryOptions"
            [multiple]="true"
            placeholder="{{ 'GENERAL.CATEGORY' | translate }}"
            [searchable]="false"
            [clearable]="true"
            (change)="onCategoryOptionsChange($event)"
            data-uit="category-select"
        >
        </ng-select>
        <ng-select
            tabindex="0"
            *ngIf="availableFilterOptions"
            class="sort-field margin-to-fit-button"
            [items]="filterOptions"
            [(ngModel)]="selectedFilterOptions"
            [multiple]="true"
            placeholder="{{ 'GENERAL.FILTERS.FILTER' | translate }}"
            [searchable]="false"
            [clearable]="true"
            (change)="onFilterOptionsChange($event)"
            data-uit="filter-by-select"
        >
        </ng-select>
        <ng-select
            tabindex="0"
            *ngIf="fileTypeFilterOptions"
            class="sort-field margin-to-fit-button"
            [items]="fileTypeFilterOptions"
            [(ngModel)]="selectedFileTypeFilterOption"
            [multiple]="true"
            placeholder="{{ 'GENERAL.FILTERS.BY_FILE_TYPE' | translate }}"
            [searchable]="false"
            [clearable]="true"
            (change)="onFileTypeOptionsChange($event)"
            data-uit="file-type-select"
        >
        </ng-select>
        <div class="d-flex align-items-end" *ngIf="showUsersFilter">
            <div class="w-50">
                <input
                    #searchUsersInput
                    type="text"
                    name="userToAdd"
                    class="form-control search-users-input"
                    [(ngModel)]="userToAdd"
                    [ngbTypeahead]="searchUsers$"
                    [popupClass]="'custom-typeahead'"
                    (selectItem)="selectUser($event)"
                    [resultFormatter]="formatUserWithEmail"
                    [inputFormatter]="formatUser"
                    [resultTemplate]="resultTemplate"
                    title="{{ 'GENERAL.USERS' | translate }}"
                    placeholder="{{ 'GENERAL.USERS' | translate }}"
                />

                <ng-template #resultTemplate let-user="result" let-t="term">
                    <div class="dropdown-item-wrapper align-items-center" title="{{ user | fullNameWithEmail }}">
                        <img *ngIf="user.picture" [src]="user.picture" class="profile-img me-2" />
                        <div *ngIf="!user.picture" class="profile-img initials me-2">
                            {{ user | initials }}
                        </div>
                        <ngb-highlight [result]="user | fullNameWithEmail" [term]="t"></ngb-highlight>
                    </div>
                </ng-template>
            </div>
            <ca-spinner-icon *ngIf="usersLoading" class="mx-2 mt-0 profile-loading-spinner"></ca-spinner-icon>
            <div class="d-flex align-items-center">
                <ng-container *ngFor="let person of users">
                    <button class="btn ca-btn-icon m-0 py-0 mt-2" (click)="removePerson(person)" title="{{ person | fullNameWithEmail }}">
                        <img *ngIf="person.picture" class="profile-img" ngbTooltip="{{ person | fullName }}" [src]="person.picture" />
                        <span *ngIf="!person.picture" class="profile-img initials">{{ person | initials }}</span>
                        <ca-icon name="cross" size="l"></ca-icon>
                    </button>
                </ng-container>
            </div>
        </div>
        <ng-content select="[header]"></ng-content>
        <button
            type="button"
            *ngIf="isResetButtonShown"
            [disabled]="isCZIConversionInProgress || isLoading || totalItemsCount === 0 || isUploadInProgress"
            class="btn btn-secondary reset-btn mt-2"
            [ngClass]="
                isCZIConversionInProgress || isUploadInProgress
                    ? ''
                    : {
                          'reset-btn-position': isConversionFailedVisible && isInvalidFilesVisibile && isAddedFilesVisible,
                          'rest-btn-position-only-invalid-files': !isConversionFailedVisible && isInvalidFilesVisibile && !isAddedFilesVisible,
                          'rest-btn-position-added-and-invalid-files': !isConversionFailedVisible && isInvalidFilesVisibile && isAddedFilesVisible,
                          'reset-btn-position-no-added-files': (isConversionFailedVisible || isInvalidFilesVisibile) && !isAddedFilesVisible,
                      }
            "
            (click)="resetButtonClicked.emit()"
        >
            {{ 'GENERAL.RESET' | translate }}
        </button>
    </div>
</section>
<section class="row">
    <div class="col">
        <ca-list-progress-bar [isShown]="isLoading"></ca-list-progress-bar>
    </div>
</section>
<section class="row justify-content-start my-3" *ngIf="emptyListMessage && !totalItemsCount && !isLoading">
    <div class="col">
        <p>{{ emptyListMessage }}</p>
    </div>
</section>
<ng-content data-uit="list-content mt-3"></ng-content>
<section class="row" *ngIf="!hidePagination">
    <div class="col d-flex align-items-center position-static mt-3">
        <ca-pagination
            data-uit="list-pagination"
            *ngIf="totalItemsCount > 0"
            class="d-flex"
            [ngClass]="isPageSizeModifiable && !isUploadModal ? 'pagination-with-page-size' : 'pagination-without-page-size'"
            [totalSize]="totalItemsCount"
            [pageSize]="pageSize"
            [currentPage]="searchAndSortOptions.pageNumber"
            [pageLink]="pageLink"
            (onPageChange)="onPageChange($event)"
        ></ca-pagination>
        <ca-page-size-selection
            *ngIf="!isUploadModal && isPageSizeModifiable"
            [pageSizeStorageKey]="pageSizeStorageKey"
            (pageSizeChange)="onChildPageSizeChange($event)"
            class="ms-auto"
        ></ca-page-size-selection>
    </div>
</section>
